import script from "./TongHopVatTuPrintTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./TongHopVatTuPrintTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./TongHopVatTuPrintTemplate.vue?vue&type=style&index=0&id=ff376a20&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff376a20"]])

export default __exports__